/* qeslint-disable */

/** *********************** */
// Dispatcher
/** *********************** */

type EventListener = (...args: any[]) => void;

export class Dispatcher {
    private event_listeners: Record<string, EventListener[]> = {};

    on(type: string, listener: EventListener): void {
        if (!(type in this.event_listeners)) {
            this.event_listeners[type] = [];
        }

        const listeners = this.event_listeners[type];

        listeners.push(listener);
    }

    fire(type: string, ...args: any[]): void {
        const listeners = this.event_listeners[type];

        if (!listeners) {
            return;
        }

        for (let i = 0; i < listeners.length; i++) {
            const listener = listeners[i];

            listener.apply(listener, args);
        }
    }
}
